import script from "./DomainModelSystemRow.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelSystemRow.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelSystemRow.vue?vue&type=style&index=0&id=7d2258bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d2258bc"]])

export default __exports__